import useClassificationLabelHook from '../hooks/useClassificationLabelHook';
import ImagePreviewer from './ImagePreviewer';

const ClassificationMiddle = () => {
  const { selectedImage } = useClassificationLabelHook();

  // The grid shows thumbnails; the preview always wants the full-size object.
  const getOriginalUrl = (url) => (url ? url.replace('_thumbnail', '') : url);

  if (!selectedImage) {
    return (
      <div className="preview-section">
        <div className="no-selection">
          <div className="initial-overlay">
            <i className="feather icon-image" style={{ fontSize: '3rem' }}></i>
            <p>Select an image to preview and assign a class</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="preview-section">
      <ImagePreviewer
        src={getOriginalUrl(selectedImage.url_display ?? selectedImage.url)}
        name={selectedImage.name}
      />
    </div>
  );
};

export default ClassificationMiddle;
